export type FieldType =
  | 'VehicleLookup'
  | 'TrailerLookup'
  | 'EquipmentLookup'
  | 'Information'
  | 'Text'
  | 'YesNo'
  | 'Date'
  | 'Time'
  | 'Signature'
  | 'SignatureImage'
  | 'Number'
  | 'Dropdown'
  | 'Checkboxes'
  | 'RadioButtons'
  | 'Notes'
  | 'Images';

export interface FormField {
  type: FieldType;
  label: string;
  isRequired?: boolean;
  options?: string[];
  filter?: string;
}

export interface FormDefinition {
  title?: string;
  fields: FormField[];
}

export const FIELD_TYPES: FieldType[] = [
  'VehicleLookup',
  'TrailerLookup',
  'EquipmentLookup',
  'Information',
  'Text',
  'YesNo',
  'Date',
  'Time',
  'Signature',
  'SignatureImage',
  'Number',
  'Dropdown',
  'Checkboxes',
  'RadioButtons',
  'Notes',
  'Images',
];

export const FIELD_TYPES_WITH_OPTIONS: FieldType[] = [
  'Dropdown',
  'Checkboxes',
  'RadioButtons',
];

export const FIELD_TYPE_CATEGORIES = {
  'Input Fields': [
    'Text',
    'Number',
    'YesNo',
    'Date',
    'Time',
    'Notes',
  ] as FieldType[],
  'Selection Fields': [
    'Dropdown',
    'Checkboxes',
    'RadioButtons',
  ] as FieldType[],
  'Lookup Fields': [
    'VehicleLookup',
    'TrailerLookup',
    'EquipmentLookup',
  ] as FieldType[],
  'Special Fields': [
    'Information',
    'Signature',
    'SignatureImage',
    'Images',
  ] as FieldType[],
};

export const getFieldTypeColor = (
  type: FieldType,
): 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info' => {
  if (FIELD_TYPE_CATEGORIES['Input Fields'].includes(type)) return 'primary';
  if (FIELD_TYPE_CATEGORIES['Selection Fields'].includes(type)) return 'success';
  if (FIELD_TYPE_CATEGORIES['Lookup Fields'].includes(type)) return 'info';
  if (FIELD_TYPE_CATEGORIES['Special Fields'].includes(type)) return 'warning';
  return 'default';
};

export const getFieldTypeDisplayLabel = (type: FieldType): string => {
  if (type === 'SignatureImage') return 'Signature';
  if (type === 'Signature') return "User's Name";
  return type;
};
